import HatIcon from '@/features/letterParty/assets/images/hat.svg?react';

import type { CSSProperties } from 'react';

interface GridPosition {
	x: number;
	y: number;
}

interface HatProps {
	position: GridPosition;
	size: number;
	collected?: boolean;
}

const Hat = ({ position, size, collected }: HatProps) => {
	const sizeClamped = Math.max(20, size * 1.2);
	const offset = (sizeClamped - size) / 2;

	const wrapperStyle: CSSProperties = {
		left: position.x * size - offset,
		top: position.y * size - offset,
		width: sizeClamped,
		height: sizeClamped,
		zIndex: 100 + position.y, // Higher y = higher z-index (bottom hats appear above)
	};

	if (collected) {
		return null;
	}

	return (
		<div className="letter-party-game__hat" style={wrapperStyle} data-collected={collected}>
			<HatIcon width={sizeClamped} height={sizeClamped} />
		</div>
	);
};

export default Hat;
